export default function VideoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M13 17.5H7M17.5 14.5H2.5C1.67157 14.5 1 13.8284 1 13V2.5C1 1.67157 1.67157 1 2.5 1H17.5C18.3284 1 19 1.67157 19 2.5V13C19 13.8284 18.3284 14.5 17.5 14.5ZM13 7.75L8.5 4.75V10.75L13 7.75Z"
        stroke="#DC3545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
